module.exports = __webpack_public_path__ + "img/maria-portrait.ae9a55b7.png";